import { render } from "./CheckTicketActivation.vue?vue&type=template&id=15f6b636"
import script from "./CheckTicketActivation.vue?vue&type=script&lang=js"
export * from "./CheckTicketActivation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__